/**
 * Some of the hints haven't shown up on the patient details ie. postcode, email
Change "About you" to "Your details" as H2
Change "About the patient" to "Patient's details" as H2
Text fields using sp_dob_checker converted to DOB format
Checkboxes mandatory issue:
Default: must select all options when mandatory
Add class: "check_option" to only make you select 1 or more option when mandatory
Use nhsuk-hint class with frm_descriptions for all field types (including Section)
Error messages:
Error summary text not styled at the top of the page
Remove * indicator
Video consultation not working (dashboard)
Send a form as a reply not working (dashboard)
Incorporate a ‘Back’ button to navigate away from the form
 */

const proxySelectField = {
  id: "proxy_select",
  name: "form_author",
  type: "radio",
  label: "Who are you completing this form for?",
  hint: "For example, on behalf of a child or dependent",
  blank:
    "Select if you are completing this form on behalf of yourself or someone else",
  options: [
    {
      label: "Yourself",
      value: "myself",
    },
    {
      label: "Someone else",
      value: "someoneelse",
    },
  ],
  value: "myself",
};

const nonProxyFields = [
  {
    id: "patient_firstnames",
    name: "patient_firstnames",
    label: "What is your first name?",
    blank: "Enter your first names",
    type: "text",
    className: "nhsuk-u-width-three-quarters",
  },
  {
    id: "patient_lastname",
    name: "patient_lastname",
    label: "What is your last name?",
    blank: "Enter your last name",
    type: "text",
    className: "nhsuk-u-width-three-quarters",
  },
  {
    id: "patient_dob",
    name: "patient_dob",
    label: "What is your date of birth?",
    hint: "For example, 31 3 1980",
    blank: "Enter your date of birth",
    type: "date",
    className: " nhsuk-input--width-10",
  },
  {
    id: "contact_sex",
    name: "contact_sex",
    label: "What is your sex?",
    hint: "As recorded on your medical record",
    blank: "Select your sex",
    type: "radio",
    className: " nhsuk-input--width-10",
    options: [
      {
        label: "Male",
        value: "M",
      },
      {
        label: "Female",
        value: "F",
      },
      {
        label: "Other",
        value: "I",
      },
    ],
  },
  {
    id: "patient_postcode",
    name: "patient_postcode",
    label: "What is your postcode?",
    hint: "The one used to register with your GP",
    blank: "Enter your postcode",
    type: "postcode",
    className: " nhsuk-input--width-10",
  },
  {
    id: "contact_phone",
    name: "contact_phone",
    label: "What is your phone number?",
    blank: "Enter your phone number",
    type: "phone",
    className: " nhsuk-input--width-20",
  },
  {
    id: "contact_email",
    name: "contact_email",
    label: "What is your email address?",
    hint: "Anyone else with access to your email account may see responses sent to you",
    blank: "Enter your email address",
    type: "email",
    className: " nhsuk-input--width-20",
  },
];

const proxyFields = {
  patient: [
    {
      id: "patient_firstnames",
      name: "patient_firstnames",
      label: "What is the patient's first name?",
      blank: "Enter the patient's first names",
      type: "text",
      className: "nhsuk-u-width-three-quarters",
    },
    {
      id: "patient_lastname",
      name: "patient_lastname",
      label: "What is the patient's last name?",
      blank: "Enter the patient's last name",
      type: "text",
      className: "nhsuk-u-width-three-quarters",
    },
    {
      id: "patient_dob",
      name: "patient_dob",
      label: "What is the patient's date of birth?",
      hint: "For example, 31 3 1980",
      blank: "Enter the patient's date of birth",
      type: "date",
      className: " nhsuk-input--width-10",
    },
    {
      id: "contact_sex",
      name: "contact_sex",
      label: "What is the patient's sex?",
      hint: "As recorded on their medical record",
      blank: "Select the patient's sex",
      type: "radio",
      className: " nhsuk-input--width-10",
      options: [
        {
          label: "Male",
          value: "M",
        },
        {
          label: "Female",
          value: "F",
        },
        {
          label: "Other",
          value: "I",
        },
      ],
    },
    {
      id: "patient_postcode",
      name: "patient_postcode",
      label: "What is the patient's postcode?",
      hint: "The one used to register with their GP",
      blank: "Enter the patient's postcode",
      type: "postcode",
      className: " nhsuk-input--width-10",
    },
  ],
  proxy: [
    // Convert to Radio
    {
      id: "proxy_relationship",
      name: "proxy_relationship",
      label: "What is your relationship to the patient?",
      blank: "Select your relationship to the patient",
      type: "radio",
      className: " nhsuk-input--width-10",
      options: [
        {
          label: "Parent",
          value: "Parent",
        },
        {
          label: "Guardian",
          value: "Guardian",
        },
        {
          label: "Spouse",
          value: "Spouse",
        },
        {
          label: "Carer",
          value: "Carer",
        },
        {
          label: "Son",
          value: "Son",
        },
        {
          label: "Daughter",
          value: "Daughter",
        },
        {
          label: "Sibling",
          value: "Sibling",
        },
        {
          label: "Other",
          value: "Other",
        },
      ],
    },
    {
      id: "proxy_firstnames",
      name: "proxy_firstnames",
      label: "What is your first name?",
      blank: "Enter your first names",
      type: "text",
      className: "nhsuk-u-width-three-quarters",
    },
    {
      id: "proxy_lastname",
      name: "proxy_lastname",
      label: "What is your last name?",
      blank: "Enter your last name",
      type: "text",
      className: "nhsuk-u-width-three-quarters",
    },
    {
      id: "proxy_dob",
      name: "proxy_dob",
      label: "What is your date of birth?",
      hint: "For example, 31 3 1980",
      blank: "Enter your date of birth",
      type: "date",
      className: " nhsuk-input--width-10",
    },
    {
      id: "proxy_sex",
      name: "proxy_sex",
      label: "What is your sex?",
      hint: "As recorded on your medical record",
      blank: "Select your sex",
      type: "radio",
      className: " nhsuk-input--width-10",
      options: [
        {
          label: "Male",
          value: "M",
        },
        {
          label: "Female",
          value: "F",
        },
        {
          label: "Other",
          value: "I",
        },
      ],
    },
    {
      id: "proxy_postcode",
      name: "proxy_postcode",
      label: "What is your postcode?",
      hint: "The one used to register with your GP",
      blank: "Enter your postcode",
      type: "postcode",
      className: " nhsuk-input--width-10",
    },
    {
      id: "contact_phone",
      name: "contact_phone",
      label: "What is your phone number?",
      blank: "Enter your phone number",
      type: "phone",
      className: " nhsuk-input--width-20",
    },
    {
      id: "contact_email",
      name: "contact_email",
      label: "What is your email address?",
      hint: "Anyone else with access to your email account may see responses sent to you",
      blank: "Enter your email address",
      type: "email",
      className: " nhsuk-input--width-20",
    },
  ],
};
const createFormGroup = (id = "") => {
  const formGroup = Object.assign(document.createElement("div"), {
    className: "frm_form_field frm_required_field nhsuk-form-group",
  });
  // Set the ID
  if (id) {
    formGroup.setAttribute("id", `frm_field_${id}_container`);
  }
  const errorCallback = (mutationList, observer) => {
    for (const list of mutationList) {
      // Error found
      if (list.addedNodes.length > 0) {
        for (const node of list.addedNodes) {
          if (node.classList.contains("frm_error")) {
            formGroup.classList.add("nhsuk-form-group--error");
            node.classList.add("nhsuk-error-message", "nhsuk-u-margin-top-2");
            for (const input of formGroup.getElementsByTagName("input")) {
              input.classList.add("nhsuk-input--error");
            }
          }
        }
      }
      // Error removed
      if (list.removedNodes.length > 0) {
        formGroup.classList.remove("nhsuk-form-group--error");
        for (const input of formGroup.getElementsByTagName("input")) {
          input.classList.remove("nhsuk-input--error");
        }
      }
    }
  };
  const observer = new MutationObserver(errorCallback);
  observer.observe(formGroup, { childList: true });
  return formGroup;
};

// Create a fieldset
const createFieldset = (children = []) => {
  const element = Object.assign(document.createElement("fieldset"), {
    className: "nhsuk-fieldset",
  });
  for (const child of children) {
    element.appendChild(child);
  }
  return element;
};

const createLegend = (props) => {
  const { className = "", innerHTML } = props;
  return Object.assign(document.createElement("legend"), {
    className: `nhsuk-fieldset__legend ${className}`,
    innerHTML,
  });
};

const createHint = ({ hint }) => {
  return Object.assign(document.createElement("div"), {
    innerHTML: hint,
    className: "nhsuk-hint",
  });
};

const createInput = (props) => {
  const { id, label, className = "", hint = "", type } = props;

  const formGroup = createFormGroup(id);
  formGroup.appendChild(
    Object.assign(document.createElement("label"), {
      className: "nhsuk-label",
      innerHTML: label,
      htmlFor: id,
    })
  );

  // Check for hint text
  if (hint) {
    formGroup.appendChild(createHint({ hint }));
  }

  const input = Object.assign(document.createElement("input"), {
    ...props,
    type: type !== "email" ? type : "text",
    className: `nhsuk-input ${className}`,
    ariaRequired: "true",
  });

  //input.dataset.reqmsg = "";
  formGroup.appendChild(input);

  return formGroup;
};

const createSelect = (props) => {
  const { id, name, label, className = "", hint = "", options } = props;
  const formGroup = createFormGroup(id);
  formGroup.appendChild(
    Object.assign(document.createElement("label"), {
      className: "nhsuk-label",
      innerHTML: label,
      htmlFor: id,
    })
  );
  const select = Object.assign(document.createElement("select"), {
    className: "nhsuk-select",
    id: id,
    name: name,
  });

  for (const [index, option] of options.entries()) {
    select.appendChild(
      Object.assign(document.createElement("option"), {
        value: option.value,
        innerHTML: option.label,
      })
    );
  }

  formGroup.appendChild(select);
  return formGroup;
};

const createRadio = (props) => {
  const { id, name, label, hint = "", options, onchange, value = "" } = props;
  // Create form group
  const formGroup = createFormGroup(id);
  // Create fieldset
  const fieldset = createFieldset();
  // Append legend
  fieldset.appendChild(
    createLegend({
      innerHTML: label,
    })
  );
  // Check for hint text
  if (hint) {
    fieldset.appendChild(createHint({ hint }));
  }
  // Create radios wrapper
  const radios = Object.assign(document.createElement("div"), {
    className: "frm_opt_container nhsuk-radios",
  });
  // Loop through options
  for (const [index, option] of options.entries()) {
    const itemId = `${id}-${index}`;
    // Create item wrapper
    const item = Object.assign(document.createElement("div"), {
      className: "nhsuk-radios__item",
    });
    // Create radio input
    item.appendChild(
      Object.assign(document.createElement("input"), {
        className: "nhsuk-radios__input",
        id: itemId,
        name: name,
        type: "radio",
        value: option.value,
        checked: value === option.value ? true : false,
        onchange,
      })
    );
    // Create label
    item.appendChild(
      Object.assign(document.createElement("label"), {
        className: "nhsuk-label nhsuk-radios__label",
        innerHTML: option.label,
        htmlFor: itemId,
      })
    );
    // Append option item
    radios.appendChild(item);
  }
  fieldset.appendChild(radios);
  formGroup.appendChild(fieldset);
  return formGroup;
};

// Create date field
export const createDate = (props) => {
  const { id, name, label, hint = "" } = props;

  const formGroup = createFormGroup(id);

  // Create fieldset
  const fieldset = createFieldset();
  fieldset.appendChild(
    createLegend({
      innerHTML: label,
    })
  );

  // Check for hint text
  if (hint) {
    fieldset.appendChild(createHint({ hint }));
  }

  // Create hidden field
  formGroup.append(
    Object.assign(document.createElement("input"), {
      type: "hidden",
      id: id,
      name: name,
    })
  );

  // Individual date fields
  const dateInput = Object.assign(document.createElement("div"), {
    className: "nhsuk-date-input",
  });

  const setDate = () => {
    const day = document.getElementById(`${id}-day`);
    const month = document.getElementById(`${id}-month`);
    const year = document.getElementById(`${id}-year`);
    // Set the date
    document.getElementById(
      id
    ).value = `${day.value}/${month.value}/${year.value}`;
  };

  const dateFields = [
    {
      id: `${id}-day`,
      name: `${id}-day`,
      label: "Day",
      type: "number",
      className: "nhsuk-date-input__input nhsuk-input--width-2",
      onchange: (e) => setDate(),
      onfocusout: (e) => setDate(),
    },
    {
      id: `${id}-month`,
      name: `${id}-month`,
      label: "Month",
      type: "number",
      className: "nhsuk-date-input__input nhsuk-input--width-2",
      onchange: (e) => setDate(),
      onfocusout: (e) => setDate(),
    },
    {
      id: `${id}-year`,
      name: `${id}-year`,
      label: "Year",
      type: "number",
      className: "nhsuk-date-input__input nhsuk-input--width-4",
      onchange: (e) => setDate(),
      onfocusout: (e) => setDate(),
    },
  ];

  for (const date of dateFields) {
    const dateInputItem = Object.assign(document.createElement("div"), {
      className: "nhsuk-date-input__item",
    });
    dateInputItem.append(createInput(date));
    dateInput.append(dateInputItem);
  }

  fieldset.append(dateInput);
  formGroup.append(fieldset);
  return formGroup;
};

const createField = (props) => {
  const { type } = props;
  // switch through...
  switch (type) {
    case "text":
    case "email":
    case "phone":
    case "postcode":
      return createInput(props);
    case "date":
      return createDate(props);
    case "radio":
      return createRadio(props);
    case "select":
      return createSelect(props);
    default:
      return Object.assign(document.createElement("p"), {
        innerHTML: "Unknown field type.",
      });
  }
};

// Create the patient ID fields based target class name
export const createPatientIdFields = () => {
  // check for nonProxy
  const nonProxy = document.querySelector(
    ".sp_patient_identification_non_proxy"
  );
  if (nonProxy) {
    return createNonProxyFields(nonProxy);
  }
  // Check for proxy
  const proxy = document.querySelector(".sp_patient_identification");
  if (proxy) {
    return createProxyFields(proxy);
  }
  return;
};

// Create non-proxy fields
const createNonProxyFields = (el) => {
  // Remove contents
  el.innerHTML = "";
  // Add non-[proxy fields]
  el.append(nonProxy());
};

// Create proxy fields
const createProxyFields = (el) => {
  const { value } = proxySelectField;
  // Remove contents
  el.innerHTML = "";
  el.append(
    createRadio({ ...proxySelectField, onchange: proxySelectCallback })
  );
  if (value === "myself") {
    el.append(nonProxy());
    return;
  }
  el.append(proxyPatient(), proxy());
};

const nonProxy = () => {
  const proxy = createFieldset();

  proxy.appendChild(
    createLegend({
      innerHTML: "<h2 class='nhsuk-fieldset__heading'>Your details</h2>",
      className: " nhsuk-fieldset__legend--m",
    })
  );
  // Append proxyfields
  for (const field of nonProxyFields) {
    proxy.appendChild(createField(field));
  }
  return proxy;
};

const proxyPatient = () => {
  // Patient details
  const patient = createFieldset();

  patient.appendChild(
    createLegend({
      innerHTML: "<h2 class='nhsuk-fieldset__heading'>Patient's details</h2>",
      className: " nhsuk-fieldset__legend--m",
    })
  );
  for (let field of proxyFields.patient) {
    patient.appendChild(createField(field));
  }
  return patient;
};

const proxy = () => {
  // Patient details
  const patient = createFieldset();
  patient.appendChild(
    createLegend({
      innerHTML: "<h2 class='nhsuk-fieldset__heading'>Your details</h2>",
      className: " nhsuk-fieldset__legend--m",
    })
  );
  for (let field of proxyFields.proxy) {
    patient.appendChild(createField(field));
  }
  return patient;
};

// Proxy select callback
const proxySelectCallback = (el) => {
  proxySelectField.value = el.target.value;
  createPatientIdFields();
};

export default createPatientIdFields;
